import axios from 'axios';
import { URL_PATHS } from 'config/constants/api.constants';
import { getHomeIslandsResponse } from 'config/constants/setting.constants';

const getHome = (): Promise<getHomeIslandsResponse> => {
  return axios.get(`${URL_PATHS.API_SETTING_V1}/home`);
};

const SettingService = {
  getHome,
};

export default SettingService;
